import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Menu } from "lucide-react";

/**
 * AppLayout: renders the persistent sidebar (desktop + mobile drawer) and
 * pushes page content to the right on desktop (lg:pl-64).
 *
 * Pages keep their own headers/content; they just get rendered inside <Outlet />.
 * A floating mobile-only burger button (top-left) opens the drawer on small screens.
 */
const AppLayout = ({ user }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0f0f10]">
      <Sidebar user={user} mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />

      {/* Mobile burger (only visible <lg) */}
      <button
        onClick={() => setMobileOpen(true)}
        className="lg:hidden fixed top-3 left-3 z-30 p-2 bg-[#1a1a1b]/90 border border-red-900/30 rounded-lg text-gray-200 hover:text-white"
        data-testid="layout-mobile-menu"
        aria-label="Buka menu"
      >
        <Menu size={20} />
      </button>

      <div className="lg:pl-64">
        <Outlet />
      </div>
    </div>
  );
};

export default AppLayout;
